<template>
  <v-snackbar
      max-width="500"
      v-model="state.visible"
      :timeout="state.timeout"
      :color="state.type"
      location="top center"
  >
    <v-row>
      <v-col cols="1">
        <v-icon :icon="iconMap[state.type]" />
      </v-col>
      <v-spacer />
      <v-col cols="auto">
        <span>{{ state.message }}</span>
      </v-col>
      <v-col>

      </v-col>
    </v-row>
  </v-snackbar>
</template>

<script setup>
import { inject } from 'vue'
// inject the global notifier state
const { state } = inject('notifier')
// map notification type -> icon
const iconMap = {
  success: 'fas fa-check-circle',
  error: 'fas fa-times',
  info: 'fas fa-info-circle',
  warning: 'fas fa-exclamation-triangle',
}
</script>
